import { render, staticRenderFns } from "./ListOrderPlatform.vue?vue&type=template&id=a592ebba"
import script from "./ListOrderPlatform.vue?vue&type=script&lang=js"
export * from "./ListOrderPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports